{
  "name": "header",
  "type": "module",
  "private": true,
  "contributors": [
    {
      "name": "Quentin Guillemin",
      "email": "quentin.guillemin@recia.fr",
      "url": "https://github.com/Quentin-Guillemin"
    }
  ],
  "license": "Apache-2.0",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/r-header.js"
      },
      "require": {
        "types": "./dist/index.d.ts",
        "default": "./dist/r-header.js"
      }
    },
    "./types/*": "./src/types/*"
  },
  "main": "./dist/r-header.js",
  "module": "./dist/r-header.js",
  "scripts": {
    "dev": "vite --host",
    "build": "tsc && yarn build:style && vite build",
    "preview": "vite preview",
    "test:unit": "echo No tests available",
    "build:style": "sass -p node -s compressed --error-css --update --no-source-map src/assets/scss/:src/assets/css/",
    "local:header": "concurrently --kill-others -n 'json,sass,vite' -c auto --pad-prefix 'yarn dev:json-server' 'yarn build:style --watch' 'yarn dev'"
  },
  "dependencies": {
    "@lit/localize": "^0.12.2",
    "lit": "^3.3.3"
  },
  "devDependencies": {
    "@antfu/eslint-config": "^10.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@fortawesome/free-regular-svg-icons": "^7.3.1",
    "@fortawesome/free-solid-svg-icons": "^7.3.1",
    "@gip-recia/ui": "workspace:^",
    "@lit/localize-tools": "^0.8.2",
    "@nanostores/lit": "^0.2.3",
    "@types/lodash-es": "^4",
    "@types/node": "^24",
    "@types/regenerator-runtime": "^0",
    "@typescript/native": "npm:typescript@^7.0.2",
    "@uportal/open-id-connect": "^1.40.2",
    "bottom-sheet": "workspace:^",
    "common": "workspace:^",
    "concurrently": "^10.0.6",
    "date-fns": "^4.4.0",
    "eslint": "^10.14.0",
    "eslint-plugin-format": "^2.0.1",
    "filters": "workspace:^",
    "lodash-es": "^4.18.1",
    "match-sorter": "^8.3.0",
    "nanostores": "^1.5.5",
    "regenerator-runtime": "^0.14.1",
    "ress": "^6.0.0",
    "sass": "^1.107.1",
    "tabbable": "^6.5.1",
    "typescript": "npm:@typescript/typescript6@^6.0.2",
    "unplugin-dts": "^1.1.2",
    "vite": "^8.3.5"
  }
}
